// Sistema de validação de dados
export interface ValidationError {
  field: string;
  message: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
}

// Validação de manifestação
export const validateManifestation = (data: {
  titulo?: string;
  descricao?: string;
  categoria?: string;
  prioridade?: string;
  comunidade?: string;
}): ValidationResult => {
  const errors: ValidationError[] = [];

  if (!data.titulo || data.titulo.trim().length < 3) {
    errors.push({
      field: 'titulo',
      message: 'O título deve ter pelo menos 3 caracteres',
    });
  }

  if (data.titulo && data.titulo.length > 200) {
    errors.push({
      field: 'titulo',
      message: 'O título não pode ter mais de 200 caracteres',
    });
  }

  if (!data.descricao || data.descricao.trim().length < 10) {
    errors.push({
      field: 'descricao',
      message: 'A descrição deve ter pelo menos 10 caracteres',
    });
  }

  if (data.descricao && data.descricao.length > 2000) {
    errors.push({
      field: 'descricao',
      message: 'A descrição não pode ter mais de 2000 caracteres',
    });
  }

  if (!data.categoria) {
    errors.push({
      field: 'categoria',
      message: 'Selecione uma categoria',
    });
  }

  if (!data.prioridade) {
    errors.push({
      field: 'prioridade',
      message: 'Selecione uma prioridade',
    });
  }

  if (!data.comunidade) {
    errors.push({
      field: 'comunidade',
      message: 'Selecione uma comunidade',
    });
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

// Validação de email
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validação de senha
export const validatePassword = (password: string): ValidationResult => {
  const errors: ValidationError[] = [];

  if (password.length < 8) {
    errors.push({
      field: 'password',
      message: 'A senha deve ter pelo menos 8 caracteres',
    });
  }

  if (!/[A-Z]/.test(password)) {
    errors.push({
      field: 'password',
      message: 'A senha deve conter pelo menos uma letra maiúscula',
    });
  }

  if (!/[a-z]/.test(password)) {
    errors.push({
      field: 'password',
      message: 'A senha deve conter pelo menos uma letra minúscula',
    });
  }

  if (!/[0-9]/.test(password)) {
    errors.push({
      field: 'password',
      message: 'A senha deve conter pelo menos um número',
    });
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

// Sanitização de strings
export const sanitizeString = (str: string): string => {
  return str
    .trim()
    .replace(/[<>]/g, '') // Remove < e >
    .replace(/javascript:/gi, '') // Remove javascript:
    .replace(/on\w+=/gi, ''); // Remove event handlers
};

// Validação de comunidade
export const validateCommunity = (data: {
  name?: string;
  city?: string;
  population?: number;
  type?: string;
}): ValidationResult => {
  const errors: ValidationError[] = [];

  if (!data.name || data.name.trim().length < 3) {
    errors.push({
      field: 'name',
      message: 'O nome deve ter pelo menos 3 caracteres',
    });
  }

  if (!data.city || data.city.trim().length < 2) {
    errors.push({
      field: 'city',
      message: 'A cidade deve ter pelo menos 2 caracteres',
    });
  }

  if (!data.population || data.population < 0) {
    errors.push({
      field: 'population',
      message: 'A população deve ser um número positivo',
    });
  }

  if (!data.type) {
    errors.push({
      field: 'type',
      message: 'Selecione um tipo de comunidade',
    });
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
